// 公共方法：将字符串按分隔符分割为数组
export const splitToArray = (value, separator = ',', type = 1) => {
  if (!value) {
    return type == 1 ? ['', ''] : []
  }
  const result = value.split(separator)
  // 确保返回长度为2的数组
  if (result.length === 1) {
    return type == 1 ? [result[0], ''] : [result[0]]
  }
  return result
}

// 公共方法：将时间字符串转换为时间戳数组
export const parseTimeToTimestamp = (time) => {
  if (typeof time !== 'object') {
    return time ? time.split('-').map((t) => t * 1000) : []
  }
  return time
}

// 公共方法：处理以 '-' 开头的字符串
export const processSpecialValue = (value, setFlagMethod) => {
  if (value && value.length > 0 && value[0] && value[0].charAt(0) === '-') {
    setFlagMethod(true)
    value[0] = value[0].substring(1)
  }
  return value
}

// 格式化数据
export const formatList = (data) => {
  let newArr = {}
  for (let i in data) {
    if (typeof data[i] === 'object' && data[i] !== null && Array.isArray(data[i]) && i != 'certificateType') {
      if (data[i].length > 0) {
        if (data[i][0] !== null && data[i][0] !== '' && data[i][0] !== undefined) {
          if (
            data[i][1] != null &&
            data[i][1] != undefined &&
            data[i][1] != ''
          ) {
            if (i === 'registerTime' || i === 'positiveTime') {
              newArr[i] = `${data[i][0] / 1000}-${data[i][1] / 1000}`
            } else {
              newArr[i] = `${data[i][0]}-${data[i][1]}`
            }
          } else {
            newArr[i] = data[i][0] + '-'
          }
        }
      }
    } else {
      if (data[i] !== '' && data[i] !== null) {
        newArr[i] = data[i]
      }
    }
  }
  return newArr
}

// 格式化日期
export const formatDate = (row, column) => {
  // 获取单元格数据
  let data = row[column.property] * 1000
  if (data == null) {
    return null
  }
  let dt = new Date(data)
  return (
    dt.getFullYear() +
    '-' +
    (dt.getMonth() + 1) +
    '-' +
    dt.getDate() +
    ' ' +
    dt.getHours() +
    ':' +
    dt.getMinutes() +
    ':' +
    dt.getSeconds()
  )
} 